module.exports = __webpack_public_path__ + "img/VRTS.91d17cbf.png";